export default __webpack_public_path__ + "static/media/will.af66d17c.png";